import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { NavLink } from 'react-router-dom';
import LogoutButton from '../LogoutButton/LogoutButton';

interface NavBarProps {
  isAdmin: boolean | null;
}

const NavBar: React.FC<NavBarProps> = ({ isAdmin }) => {
  const { user } = useAuth0();

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
      <div className="container">
        <NavLink className="navbar-brand" to="/dashboard">
          App Dashboard
        </NavLink>
        <div className="d-flex align-items-center">
          {user && (
            <>
            {isAdmin && (
              <>
                <NavLink className="nav-link" to="/dashboard/admin">
                  Manage Apps
                </NavLink>
                <NavLink className="nav-link" to="/dashboard/users">
                  Manage Users
                </NavLink>
                <NavLink className="nav-link" to="/dashboard/roles">
                  Manage Roles
                </NavLink>
              </>
            )}
            <span className="navbar-text me-3">
              Hello, {user.given_name || user.nickname}
            </span>
            </>
          )}
          <LogoutButton />
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
